<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    <span v-if="isUpdate">
                        {{ $t('editar-contato') }}
                    </span>
                    <span v-else>
                        {{ $t('adicionar-contato') }}
                    </span>
                    <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                        <b-icon v-if="!hide.infoIsHidden" icon="eye-off-outline" type="is-danger" />
                        <b-icon v-if="hide.infoIsHidden" icon="eye-outline" type="is-success" />
                    </a>
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="fecharModal()">
                    {{ $t('cancelar') }}
                </button>
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="saveValidations"
                    :disabled="isSaving || conflito.has"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <br />

        <div v-if="conflito.has" class="notification is-danger is-light mb-2 p-2">
            {{
                $t('msg-configuracao-conflitante-gerenciador', { n: $t('contato') })
            }}. <br />
            {{ $t('msg-favor-corrigir') }}
            <hr class="mt-2 mb-2" />
            <p v-if="conflito.config">
                {{ $t('msg-conflito-config', { n: conflitoFieldConfig }) }}
            </p>
            <p v-if="conflito.oculto">
                {{ $t('msg-conflito-oculto', { n: conflitoFieldOculto }) }}
            </p>
        </div>

        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <!-- 
                Validação de pdadetalhe: *o campo só aparece se tiver pdadetalhe configurado
                oculta - v-if
                label - title - disableMLtitle - tooltipLabel *se tem pdadetalhe não mostra o tooltipLabel
                altera - disabled 
                validchars - validchars
                maxlength - maxlength *caso for zero, pegar na coluna no mysql
                obrigainclusao - required - invalid *verificar no banco se é não null, se for sempre vai ser required
                altera - disabled
                obrigaalteracao - fazer regra no save
                -->
                <div class="column is-4">
                    <v-input
                        :id="generateId(22)"
                        ref="idErpInput"
                        v-model="contato.idcontatoerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        required
                        tooltipLabel="cod-ref"
                        :invalid="!contato.idcontatoerp"
                        uppercase
                    />
                </div>

                <div class="column is-8" v-if="pdadetalhe['nome'] && !pdadetalhe['nome'].oculta">
                    <v-input
                        :id="generateId(50)"
                        ref="nome"
                        v-model="contato.nome"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['nome'].label) ? pdadetalhe['nome'].label : 'nome'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['nome'].label)"
                        :msg="pdadetalhe['nome'].msg"
                        :invalid="pdadetalhe['nome'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('nome')"
                        :required="Obligation('nome')"
                        :tooltipLabel="
                            isNull(pdadetalhe['nome'].label) ? 'informacao-contato-nome' : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || (isUpdate && pdadetalhe['nome'].altera == 0)"
                        :validchars="pdadetalhe['nome'].validchars"
                        :maxlength="
                            pdadetalhe['nome'].maxlength > 0 ? pdadetalhe['nome'].maxlength : 50
                        "
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="pdadetalhe['dataani'] && !pdadetalhe['dataani'].oculta"
                >
                    <verified-date-picker
                        :id="generateId(40)"
                        ref="dataani"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="datanascimento"
                        placeholder="selecione-uma-data"
                        :title="
                            !isNull(pdadetalhe['dataani'].label)
                                ? pdadetalhe['dataani'].label
                                : 'data-nascimento'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['dataani'].label)"
                        :required="Obligation('dataani')"
                        :invalid="pdadetalhe['dataani'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('dataani')"
                        :msg="pdadetalhe['dataani'].msg"
                        :subtractDateYears="80"
                        :yearsRange="[-50, 50]"
                        :inForm="true"
                        :tooltipLabel="
                            isNull(pdadetalhe['dataani'].label)
                                ? 'informacao-contato-data-nascimento'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || (isUpdate && pdadetalhe['dataani'].altera == 0)"
                    />
                </div>
                <div class="column is-6" v-if="pdadetalhe['email'] && !pdadetalhe['email'].oculta">
                    <v-input
                        :id="generateId(200)"
                        ref="email"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="contato.email"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['email'].label) ? pdadetalhe['email'].label : 'email'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['email'].label)"
                        :msg="pdadetalhe['email'].msg"
                        :invalid="pdadetalhe['email'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('email')"
                        :required="Obligation('email')"
                        type="email"
                        :tooltipLabel="
                            isNull(pdadetalhe['email'].label) ? 'informacao-contato-email' : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || (isUpdate && pdadetalhe['email'].altera == 0)"
                        :validchars="pdadetalhe['email'].validchars"
                        :maxlength="
                            pdadetalhe['email'].maxlength > 0 ? pdadetalhe['email'].maxlength : 50
                        "
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="pdadetalhe['telefone'] && !pdadetalhe['telefone'].oculta"
                >
                    <v-input-tel
                        :id="generateId(170)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="telefone"
                        v-model="contato.telefone"
                        :title="
                            !isNull(pdadetalhe['telefone'].label)
                                ? pdadetalhe['telefone'].label
                                : 'telefone'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['telefone'].label)"
                        :msg="pdadetalhe['telefone'].msg"
                        :invalid="pdadetalhe['telefone'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('telefone')"
                        :required="Obligation('telefone')"
                        :disabled="cantEdit || (isUpdate && pdadetalhe['telefone'].altera == 0)"
                        :edit="inputTelefoneEdit"
                        :tooltipLabel="
                            isNull(pdadetalhe['telefone'].label)
                                ? 'informacao-contato-telefone'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :maxlength="20"
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="pdadetalhe['depart'] && !pdadetalhe['depart'].oculta"
                >
                    <v-input
                        :id="generateId(51)"
                        ref="depart"
                        v-model="contato.depto"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['depart'].label)
                                ? pdadetalhe['depart'].label
                                : 'depto'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['depart'].label)"
                        :msg="pdadetalhe['depart'].msg"
                        :invalid="pdadetalhe['depart'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('depart')"
                        :required="Obligation('depart')"
                        :tooltipLabel="
                            isNull(pdadetalhe['depart'].label) ? 'informacao-contato-depto' : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || (isUpdate && pdadetalhe['depart'].altera == 0)"
                        :validchars="pdadetalhe['depart'].validchars"
                        :maxlength="
                            pdadetalhe['depart'].maxlength > 0 ? pdadetalhe['depart'].maxlength : 50
                        "
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="pdadetalhe['cnpjcpf'] && !pdadetalhe['cnpjcpf'].oculta"
                >
                    <v-input
                        :id="generateId(80)"
                        :key="generateId(80)"
                        ref="cnpjcpf"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="contato.cpf"
                        :title="
                            !isNull(pdadetalhe['cnpjcpf'].label)
                                ? pdadetalhe['cnpjcpf'].label
                                : 'cnpj-cpf'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                        placeholder="placeholder-preencha"
                        :msg="pdadetalhe['cnpjcpf'].msg"
                        :invalid="pdadetalhe['cnpjcpf'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                        :useMask="true"
                        :vMask="['###.###.###-##', '##.###.###/####-##']"
                        :required="Obligation('cnpjcpf')"
                        :tooltipLabel="
                            isNull(pdadetalhe['cnpjcpf'].label)
                                ? 'informacao-contato-cnpjcpf'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :disabled="cantEdit || (isUpdate && pdadetalhe['cnpjcpf'].altera == 0)"
                    />
                </div>
                <div class="column is-6" v-if="pdadetalhe['obs'] && !pdadetalhe['obs'].oculta">
                    <v-input
                        :id="generateId(52)"
                        ref="obs"
                        v-model="contato.obs"
                        placeholder="placeholder-preencha"
                        :title="!isNull(pdadetalhe['obs'].label) ? pdadetalhe['obs'].label : 'obs'"
                        :disableMLtitle="!isNull(pdadetalhe['obs'].label)"
                        :msg="pdadetalhe['obs'].msg"
                        :invalid="pdadetalhe['obs'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('obs')"
                        :required="Obligation('obs')"
                        :tooltipLabel="
                            isNull(pdadetalhe['obs'].label) ? 'informacao-contato-observacao' : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || (isUpdate && pdadetalhe['obs'].altera == 0)"
                        :validchars="pdadetalhe['obs'].validchars"
                        :maxlength="
                            pdadetalhe['obs'].maxlength > 0 ? pdadetalhe['obs'].maxlength : 50
                        "
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssContatoCliente from '@/services/vendas/cliente/abas/ContatoService';
import Message from '@/models/Message';
import ContatoValidation from '@/services/validations/vendas/cliente/ContatoValidation';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        HideInfo,
    },
    props: {
        idContato: {
            type: Number,
            default: null,
        },
        idCliente: {
            type: Number,
            default: null,
        },
        integracao: {
            type: Boolean,
            default: true,
        },
        permissao: {
            type: Object,
            default: () => {},
        },
        isAtendimento: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            cleanHide: true,
            service: new AssContatoCliente(this.$http, this.$router),
            validation: new ContatoValidation(this.msgs),

            isLoading: false,
            isSaving: false,
            msgs: [],

            // dados para comparação em obrigaalteracao
            contatoOld: null,
            contato: {
                idcontato: null,
                idcontatoerp: null,
                idcliente: this.idCliente,
                nome: null,
                telefone: null,
                datanascimento: null, //dataani
                depto: null, // depart
                email: null,
                obs: null,
                cpf: null, // cnpjcpf
            },
            // campos com código campo em pdadetalhe direfente da chave da coluna
            tests: ['dataani', 'depart', 'cnpjcpf'],

            datanascimento: null,
            invalidTelefone: false,
            invalidCpf: false,
            invalidEmail: false,
            invalidNome: false,
            invalidNomeMsg: 'msg-campo-obrigatorio',
            invalidTelefoneMsg: 'msg-campo-invalido',
            invalidCpfMsg: 'msg-campo-invalido',
            invalidEmailMsg: 'msg-campo-invalido',
            errorValidation: false,
            inputTelefoneEdit: false,

            pdadetalhe: {},
            pdadetalheHasData: false,
            
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            startedData: false,
            // regra para exibissão de conflito entre as configs do modulopdadetalhe e o banco de dados
            conflito: {
                has: false,
                config: false,
                oculto: false,
            },
            conflitoFieldConfig: '',
            conflitoFieldOculto: '',
            cantEdit: false,
            isUpdate: false,

            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    computed: {
        ...mapState(['hide']),
    },
    created() {
        this.isUpdate = this.idContato != null;
        this.getModulo('CONTATO').detalhe.forEach((d) => {
            d.invalid = false;
            d.msg = 'msg-campo-obrigatorio';
            this.$set(this.pdadetalhe, d.campo.toLowerCase(), d);
            // Caso tenha dados em pdadetalhe
            this.pdadetalheHasData = true;
        });

        /* validação por campos não nulos na tabela contato;
      Caso um destes campos não estejam configurados corretamente, 
      avisar para ajustar o modulopdadetalhe no mobileManager */
        let fields = ['nome'];
        fields.forEach((field) => {
            this.checkInvalidConfig(field);
        });

        if (this.isUpdate) {
            if (this.integracao) this.cantEdit = this.integracao;
            if (!this.permissao.update) this.cantEdit = !this.permissao.update;

            this.carregarDados(this.idContato);
        }
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        checkInvalidConfig(field) {
            if (!this.pdadetalhe[field]) {
                this.conflitoFieldConfig += ' *' + this.$t(field);
                this.conflito.has = true;
                this.conflito.config = true;
            }
            if (this.pdadetalhe[field] && this.pdadetalhe[field].oculta) {
                this.conflitoFieldOculto += ' *' + this.$t(field);
                this.conflito.has = true;
                this.conflito.oculto = true;
            }
            if (this.conflito.has) this.cantEdit = this.conflito.has;
        },

        validadeByPdaDetalhe(field) {
            //manda valores dos objetos internos para o objeto de cliete
            this.sendValuesToContato(field);
            // limpa a validação para iniciar os testes
            this.pdadetalhe[field].invalid = false;

            setTimeout(() => {
                if (this.customValidations(field)) {
                    // valida campos com validações adicionais
                    return this.pdadetalhe[field].invalid;
                } else if (this.obrigaAlteracao(field)) {
                    // validação pelo pdadetalhe
                    return this.pdadetalhe[field].invalid;
                } else if (this.obrigaInclusao(field)) {
                    // valida por obrigainclusao
                    return this.pdadetalhe[field].invalid;
                }

                return this.pdadetalhe[field].invalid;
            }, 100);
        },
        sendValuesToContato(field) {
            if (field == 'dataani') {
                this.contato.datanascimento =
                    this.datanascimento != null && this.$moment(this.datanascimento).isValid()
                        ? this.$moment(this.datanascimento).format('YYYY-MM-DD')
                        : null;
            }
        },
        customValidations(field) {
            let fieldContato = field;
            if (field == 'dataani') fieldContato = 'datanascimento';
            if (field == 'depart') fieldContato = 'depto';
            if (field == 'cnpjcpf') fieldContato = 'cpf';

            if (field == 'cnpjcpf') {
                if (
                    !this.isNull(this.contato[fieldContato]) &&
                    !this.validateCPF(this.contato[fieldContato]) &&
                    !this.validateCnpj(this.contato[fieldContato])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = 'msg-campo-invalido';
                }
            } else if (field == 'telefone') {
                // if(!this.isNull(this.contato[field])&&!this.validatePhone(this.contato[field])) {
                //     this.pdadetalhe[field].invalid = true;
                //     this.pdadetalhe[field].msg = 'msg-campo-invalido';
                // }
            } else if (field == 'email') {
                if (!this.isNull(this.contato[field]) && !this.validateEmail(this.contato[field])) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = 'msg-campo-invalido';
                }
            }

            return this.pdadetalhe[field].invalid;
        },
        obrigaAlteracao(field) {
            // faz ajustes para campos com código campo em pdadetalhe direfente da chave da coluna
            let fieldContato = field;
            if (field == 'dataani') fieldContato = 'datanascimento';
            if (field == 'depart') fieldContato = 'depto';
            if (field == 'cnpjcpf') fieldContato = 'cpf';

            if (this.isUpdate && this.pdadetalhe[field].obrigaalteracao) {
                // Só faz toUpperCase se for texto
                let oldValue = this.contatoOld[fieldContato];
                oldValue =
                    !this.isNull(oldValue) ||
                    (!this.isNull(oldValue) && !this.onlyNumbers(oldValue))
                        ? oldValue.toString().toUpperCase()
                        : oldValue;
                let newValue = this.contato[fieldContato];

                let fieldsToClean = ['cpf'];
                let fieldsToCleanTel = ['telefone'];
                if (fieldsToClean.concat(fieldsToCleanTel).includes(fieldContato)) {
                    if (fieldsToCleanTel.includes(fieldContato)) {
                        let oldValueSplit = oldValue.split(' ');
                        let newValueSplit = newValue.split(' ');

                        if (!(oldValueSplit[0] && oldValueSplit[0].length == 2))
                            oldValue = 'BR' + oldValue;
                        if (!(newValueSplit[0] && newValueSplit[0].length == 2))
                            newValue = 'BR' + newValue;
                    }

                    oldValue = oldValue.replace(/[^a-zA-Z0-9]/g, '');
                    newValue = newValue.replace(/[^a-zA-Z0-9]/g, '');
                }

                newValue =
                    !this.isNull(newValue) ||
                    (!this.isNull(newValue) && !this.onlyNumbers(newValue))
                        ? newValue.toString().toUpperCase()
                        : newValue;

                if (oldValue == newValue) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = 'msg-obriga-alteracao';
                }
            }

            return this.pdadetalhe[field].invalid;
        },
        obrigaInclusao(field) {
            // faz ajustes para campos com código campo em pdadetalhe direfente da chave da coluna
            let fieldContato = field;
            if (field == 'dataani') fieldContato = 'datanascimento';
            if (field == 'depart') fieldContato = 'depto';
            if (field == 'cnpjcpf') fieldContato = 'cpf';

            if (this.pdadetalhe[field].obrigainclusao && this.isNull(this.contato[fieldContato])) {
                this.pdadetalhe[field].invalid = true;
                this.pdadetalhe[field].msg = 'msg-campo-obrigatorio';
            }

            return this.pdadetalhe[field].invalid;
        },
        saveValidations() {
            this.isLoading = true;
            let invalid = false;

            let invalidFields = '';

            // inicia validação dos campos extras
            this.checkValidations = true;

            setTimeout(() => {
                // inicia validação dos campos do pdadetalhe
                Object.entries(this.$refs).forEach(([key, value]) => {
                    if (this.pdadetalhe[key]) {
                        this.validadeByPdaDetalhe(key);
                    }
                });
                setTimeout(() => {
                    // Por questão de tempo de execução estou recuperando se há campo inválido após as validações estarem completas
                    Object.entries(this.$refs).forEach(([key, value]) => {
                        if (this.pdadetalhe[key]) {
                            if (this.pdadetalhe[key].invalid) {
                                invalid = true;
                                invalidFields += ' - ' + key;
                            }
                        }
                    });
                    if (invalid) {
                        console.warn('Campos inválidos', invalidFields);
                        // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                        Object.entries(this.$refs).forEach(([key, value]) => {
                            if (value != undefined) value.focusedOut = true;
                        });
                        this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));

                        this.isLoading = false;
                    } else {
                        // passou por todas as validações
                        this.save();
                    }
                }, 2000);
            }, 1000);
        },
        save() {
            let contatoTemp = Object.assign({}, this.contato);
            contatoTemp = this.mapTosave(contatoTemp, 'cnpjcpf', 'datanascimento');
            this.isSaving = true;
            this.saveContato(contatoTemp)
                .then((value) => {
                    if (value.message == null) {
                        let msg =
                            this.contato.idcontato != null
                                ? 'msg-edit-cliente-contato'
                                : 'msg-save-cliente-contato';
                        this.msgs.push(new Message('success', msg, true));
                        this.$emit('isChanged', false);

                        if (this.isAtendimento) {
                            setTimeout(() => {
                                this.$emit('closeAndReload', true);
                                this.clearContato();
                            }, 1500);
                        } else {
                            setTimeout(() => {
                                this.$emit('fecharModal', true);
                            }, 1500);
                        }

                        this.errorValidation = false;
                    } else {
                        if (this.$te(value.message)) {
                            if (value.message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(value.message, { n: contatoTemp.idcontatoerp }),
                                        true,
                                        false
                                    )
                                );
                            } else if (value.message) {
                                this.msgs.push(new Message('alert', value.message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    if (e.body.status == 409) {
                        this.msgs.push(new Message('alert', 'msg-existe-codigo-contato', true));
                    } else {
                        console.error('Erro ao salvar: ' + e);
                        this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                    }
                })
                .finally(() => {
                    this.isSaving = false;
                    this.cleanHide = false;
                    this.isLoading = false;
                });
        },
        clearContato() {
            this.contato = {
                idcontato: null,
                idcontatoerp: null,
                idcliente: this.idCliente,
                nome: null,
                telefone: null,
                datanascimento: null,
                depto: null,
                email: null,
                obs: null,
                cpf: null,
            };
        },
        saveContato(contato) {
            if (this.isVenda) return this.service.saveVendas(contato);
            else return this.service.saveAgro(contato);
        },
        carregarDados(id) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.find(id)
                .then((body) => {
                    Object.entries(this.contato).forEach(([key, value]) => {
                        if (body.content[key]) {
                            this.contato[key] = this.isNull(body.content[key])
                                ? null
                                : body.content[key];
                        }
                    });
                    if (this.contato.datanascimento != null) {
                        if (this.$moment(this.contato.datanascimento).isValid()) {
                            this.datanascimento = this.$moment(
                                this.contato.datanascimento
                            ).toDate();
                            this.contato.datanascimento = this.$moment(
                                this.contato.datanascimento
                            ).format('YYYY-MM-DD');
                        }
                    }
                    // para comparação nos modulopdadetalhe com obrigação de alteração
                    this.contatoOld = Object.assign({}, this.contato);
                })
                .catch((e) => {
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.inputTelefoneEdit = !this.isNull(this.contato.telefone);
                    setTimeout(() => {
                        this.isLoadingEdit = false;

                        this.$emit('isChanged', false);
                        this.runValidations(true);
                    }, 700);
                    this.isLoading = false;
                });
        },
        find(id) {
            if (this.isVenda) return this.service.findVendas(id);
            else return this.service.findAgro(id);
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
            // Ao realizar o focusedOut no arquivo validation, as funções de validate não são chamadas, tendo assim que fazelas manualmente para poder apresentar os erros nos campos
            this.customValidations('cnpjcpf');
            this.customValidations('telefone');
            this.customValidations('email');
        },
        generateId(numberId) {
            return this.$route.name + '-contato-' + numberId;
        },
        fecharModal() {
            this.$emit('fecharModal', true);
        },
        // @87143 - necessario validacao pela obrigaalteracao e obrigainclusao no gerenciador
        Obligation(campo) {
            let obligation = false;
            if (this.isUpdate) {
                obligation = this.pdadetalhe[campo].obrigaalteracao;
            } else {
                obligation = this.pdadetalhe[campo].obrigainclusao;
            }
            return obligation;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 30px 30px;
}
</style>
